import { useEffect, useState } from "react";
import { getCardsKpi } from "./api";
import apiCalls from "src/api/apiCalls";
import Loader from "src/components/loader.component";
import { Alert } from "react-bootstrap";
import NumberFormat from "react-number-format";
import ViewModal from "./viewModal";
const CardsKpi = ({ customClass }) => {
    const initialBalanceState = { data: [], loading: false, error: null };
    const [balances, setBalances] = useState({
        gas: initialBalanceState,
        card: initialBalanceState,
        crypto: initialBalanceState,
        provider: initialBalanceState,
    });
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [balanceType, setBalanceType] = useState(null);
    const [popupData, setPopupData] = useState(null);
    const [currencySymbol, setCurrencySymbol] = useState(null);
    useEffect(() => {
        handleInitialization();
    }, []);
    const handleInitialization = async () => {
        setBalances(prev => ({
            gas: { ...prev.gas, loading: true },
            card: { ...prev.card, loading: true },
            crypto: { ...prev.crypto, loading: true },
            provider: { ...prev.provider, loading: true },
        }));
        try {
            const [gasResponse, cardResponse, cryptoResponse, providerBalance] = await Promise.all([
                getCardsKpi('GasStation'),
                getCardsKpi('CardsBalances'),
                getCardsKpi('CryptoBalances'),
                getCardsKpi('ProviderBalance'),
            ]);
            setBalances({
                gas: handleResponse(gasResponse),
                card: handleResponse(cardResponse),
                crypto: handleResponse(cryptoResponse),
                provider: handleResponse(providerBalance),
            });
        } catch (error) {
            setBalances(prev => ({
                gas: { ...prev.gas, loading: false, error: apiCalls.isErrorDispaly(error) },
                card: { ...prev.card, loading: false, error: apiCalls.isErrorDispaly(error) },
                crypto: { ...prev.crypto, loading: false, error: apiCalls.isErrorDispaly(error) },
                provider: { ...prev.provider, loading: false, error: apiCalls.isErrorDispaly(error) },
            }));
        }
    };
    const handleResponse = (response) => ({
        data: response?.ok ? response?.data : [],
        loading: false,
        error: response?.ok ? null : apiCalls.isErrorDispaly(response),
    });
    const showView = (type, balanceList, symbole) => {
        setCurrencySymbol(symbole);
        setIsPopupOpen(true);
        setBalanceType(type);
        setPopupData(balanceList);
    };
    const closeModal = () => {
        setIsPopupOpen(false);
        setBalanceType(null);
        setPopupData(null);
    };
    const renderBalanceList = (type, data) => {
        return data?.length > 0 && data?.map((item) => (
            <div className="flex items-center justify-between mb-4" key={item?.name || item?.currency || item?.coin}>
                <p className="text-light-textGray text-sm font-sans font-normal mb-0.5">
                    {item?.name?.toUpperCase() || item?.currency?.toUpperCase() || item?.coin?.toUpperCase()}
                    {type === "crypto" && ` (${item?.type})`}
                </p>
                <h3
                    className={`${item?.coinBalances?.length > 0 ? 'text-light-primaryColor cursor-pointer' : 'text-light-addonColor'} text-sm font-sans font-medium mb-0.5`}
                    onClick={() => item?.coinBalances?.length > 0 && showView(type, item.coinBalances, item.symbol)}
                >
                    {item?.symbol} {" "}
                    <NumberFormat
                        value={item?.gasBalance || item?.balance || 0}
                        displayType="text"
                        thousandSeparator
                        decimalScale={type === 'crypto' ? 4 : 2}
                        className="font-medium"
                    />
                </h3>
            </div>
        ))
    };
    const renderSection = (title, type) => {
        const { data, error } = balances[type];
        if (data?.length === 0 && !error) return null;
        return (
            <div className={`bg-light-cardBg border border-light-cardBorder px-3 py-4 rounded-2xl analytics-card ${customClass} mb-5`}>
                <h3 className="text-light-primaryColor text-lg font-bold mb-3">{title}</h3>
                {error && (
                    <Alert variant="danger">
                        <p style={{ color: 'red', margin: 10 }}>
                            <span className="icon error-alert me-2"></span>{error}
                        </p>
                    </Alert>
                )}
                {data?.length > 0 && renderBalanceList(type, data)}
            </div>
        );
    };
    const isLoading = Object?.values(balances)?.some(balance => balance?.loading);
    const hasErrors = Object?.values(balances)?.some(balance => balance?.error);
    const validSections = Object?.values(balances)?.filter(balance => balance?.data?.length > 0)?.length;
    const gridCols = (validSections > 3 || hasErrors) ? 'xl:grid-cols-4' : 'xl:grid-cols-3';
    return (
        <>
            {isLoading && <Loader />}
            <div className={`grid grid-cols-1 ${gridCols} md:grid-cols-4 gap-4`}>
                {renderSection("Gas Balances", "gas")}
                {renderSection("Card Balances", "card")}
                {renderSection("Crypto Balances", "crypto")}
                {renderSection("Provider Balances", "provider")}
            </div>
            {isPopupOpen && popupData && (
                <ViewModal
                    showModal={isPopupOpen}
                    closeModal={closeModal}
                    Title={balanceType === "card" ? "Card Balances" : "Crypto Balances"}
                    data={popupData}
                    currencySymbol={currencySymbol}
                />
            )}
        </>
    );
};
export default CardsKpi;
